import ProjectMembersPermissionsConfig from './ProjectMembersPermissionsConfig'

export default ProjectMembersPermissionsConfig
